import React from 'react';
import { Box, Typography } from '@heycater/design-system';
import Image, { StaticImageData } from 'next/image';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import resultsIcon from '@images/food-program-page/customer-reasons/results-icon.png';
import situationIcon from '@images/food-program-page/customer-reasons/situation-icon.png';
import solutionIcon from '@images/food-program-page/customer-reasons/solution-icon.png';

interface CustomerExampleProps {
  title: string;
  situation: string;
  solution: string;
  results: string;
  image: StaticImageData;
}

function CustomerExample(props: CustomerExampleProps) {
  const { t } = useTranslation('food_program');
  return (
    <ExampleWrapper>
      <Box
        width={{ xs: 'min(70vw, 150px)', md: 'min(20vw, 210px)' }}
        flexShrink={0}
      >
        <Image
          alt=""
          src={props.image}
          height={210}
          width={210}
          objectFit="cover"
        />
      </Box>
      <SituationList>
        <Typography
          component="h3"
          textAlign={{ xs: 'center', md: 'start' }}
          fontWeight={600}
          mb={3}
          fontSize={{ xs: 16, md: 20 }}
        >
          {props.title}
        </Typography>
        <Situation
          src={situationIcon}
          textBase={t('customerExamples.situationBase')}
          text={props.situation}
        />
        <Situation
          src={solutionIcon}
          textBase={t('customerExamples.solutionBase')}
          text={props.solution}
        />
        <Situation
          src={resultsIcon}
          textBase={t('customerExamples.resultsBase')}
          text={props.results}
        />
      </SituationList>
    </ExampleWrapper>
  );
}

interface SituationProps {
  src: StaticImageData;
  textBase: string;
  text: string;
}

function Situation({ src, textBase, text }: SituationProps) {
  return (
    <Box display="flex" alignItems="center">
      <Box flexGrow={0} height={'59px'} flexShrink={0} mr={3}>
        <Image alt="" src={src} height={59} width={59} />
      </Box>
      <Typography>
        <Typography component="span" fontWeight={600}>
          {textBase}{' '}
        </Typography>
        {text}
      </Typography>
    </Box>
  );
}

const ExampleWrapper = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing(2)}px;
  align-items: center;
  flex-direction: column;

  ${({ theme }) => theme.breakpoints.up('sm')} {
    gap: ${({ theme }) => theme.spacing(4)}px;
  }

  ${({ theme }) => theme.breakpoints.up('md')} {
    flex-direction: row;
    gap: ${({ theme }) => theme.spacing(11)}px;
  }
`;

const SituationList = styled.div`
  display: flex;
  flex-direction: column;
  text-align: start;

  gap: ${({ theme }) => theme.spacing(2)}px;
`;

export default CustomerExample;
